import { Dispatch } from 'redux';
import { logger } from 'logging';
import {
  addToAuthWishlist,
  removeFromAuthWishlist,
} from 'shared/store/auth/action';
import { wishlistAdd, wishlistRemove } from './service';

export interface AddToWishlist {
  productId: string;
  formKey: string;
}

export const addToWishlist = (params: AddToWishlist) => (dispatch: Dispatch) =>
  wishlistAdd(params)
    .then((wishlistData) => {
      dispatch(addToAuthWishlist(params.productId));
      return wishlistData;
    })
    .catch((error) => {
      logger.error(error, 'Error in Remove wishlist API');
      throw error;
    });

export interface RemoveFromWishlist {
  productId: string;
}

export const removeFromWishlist =
  (params: RemoveFromWishlist) => (dispatch: Dispatch) =>
    wishlistRemove(params)
      .then((wishlistRemoveSuccess) => {
        dispatch(removeFromAuthWishlist(params.productId));
        return wishlistRemoveSuccess;
      })
      .catch((error) => {
        logger.error(error, 'Error in Remove wishlist API');
        throw error;
      });
